/**
 *  @class
 *  @function FullMenu
 */
if (!customElements.get('full-menu')) {
  class FullMenu extends HTMLElement {
    constructor() {
      super();

      this.buttons = this.querySelectorAll('.full-menu--link-parent');
      this.header = this.closest('.header');
      this.subButtons = this.querySelectorAll('.full-menu--link-child');
      this.panel = this.querySelector('.full-menu--panel');
      this.panel1 = this.querySelector('.full-menu--panel--level-1');
      this.panel2 = this.querySelector('.full-menu--panel--level-2');
      this.cc = this.querySelector('.full-menu--cc');
      this.toggle = this.querySelector('.full-menu--toggle');
      this.panelWidth = 320;
      this.lastActiveParent = null;
    }
    connectedCallback() {
      this.buttons.forEach((button, i) => {
        button.addEventListener('mouseenter', (e) => this.onParentHover(button, e, i));
        button.addEventListener('keydown', (e) => this.onParentKeydown(button, e, i));
        button.addEventListener('focus', (e) => this.onParentFocus(button, e, i));
      });
      this.subButtons.forEach((button, i) => {
        button.addEventListener('mouseenter', (e) => this.onChildHover(button, e, i));
      });
      this.panel2.addEventListener('mouseleave', this.onPanelLeave.bind(this));
      this.toggle.addEventListener('click', this.onToggleClick.bind(this));
      this.cc.addEventListener('mousemove', this.onCC.bind(this));

      this.addEventListener('focusout', (event) => {
        if (!this.contains(event.relatedTarget)) this.onCC();
      });
      document.addEventListener('keyup', (event) => {
        if (event.code.toUpperCase() === 'ESCAPE') {
          const wasOpen = this.header.classList.contains('open-menu');
          this.onCC();
          if (wasOpen) (this.lastActiveParent || this.toggle).focus();
        }
      });
    }
    setExpandedParent(activeButton = null) {
      this.buttons.forEach((button) => {
        if (button.classList.contains('has-sub-menu')) {
          button.setAttribute('aria-expanded', (button === activeButton).toString());
        }
      });
    }
    setExpandedChild(activeButton = null) {
      this.subButtons.forEach((button) => {
        if (button.classList.contains('has-sub-menu')) {
          button.setAttribute('aria-expanded', (button === activeButton).toString());
        }
      });
    }
    onParentFocus(button) {
      this.header.classList.add('open-menu');
      this.toggle.setAttribute('aria-expanded', 'true');
      this.lastActiveParent = button;
    }
    onParentKeydown(button, e, i) {
      if (!['ENTER', 'SPACE'].includes(e.code.toUpperCase())) return;

      if (button.classList.contains('has-sub-menu')) {
        e.preventDefault();
        this.header.classList.add('open-menu');
        this.toggle.setAttribute('aria-expanded', 'true');
        let submenus = this.panel1.querySelectorAll('.full-menu--subpanel'),
          target_selector = button.dataset.target;
        this.panel.style.setProperty('--menu-panel-width', (this.panelWidth * 2) + 'px');

        [].forEach.call(submenus, function (el) {
          el.classList.remove('active');
        });
        this.panel1.querySelector(target_selector).classList.add('active');
        this.lastActiveParent = button;
        this.setExpandedParent(button);
        this.panel1.querySelector(target_selector).querySelectorAll('a')[0].focus();
      }
    }
    onParentHover(button, e, i) {
      this.header.classList.add('open-menu');
      this.toggle.setAttribute('aria-expanded', 'true');
      this.lastActiveParent = button;

      if (button.classList.contains('has-sub-menu')) {
        let submenus = this.panel1.querySelectorAll('.full-menu--subpanel'),
          target_selector = button.dataset.target;
        this.panel.style.setProperty('--menu-panel-width', (this.panelWidth * 2) + 'px');

        [].forEach.call(submenus, function (el) {
          el.classList.remove('active');
        });
        this.panel1.querySelector(target_selector).classList.add('active');
        this.setExpandedParent(button);
      } else {
        this.panel.style.setProperty('--menu-panel-width', (this.panelWidth * 1) + 'px');
        this.setExpandedParent();
      }
      window.dispatchEvent(new Event('resize'));
      e.preventDefault();
    }
    onChildHover(button, e, i) {
      if (button.classList.contains('has-sub-menu')) {
        let submenus = this.panel2.querySelectorAll('.full-menu--subpanel'),
          target_selector = button.dataset.target;

        this.panel.style.setProperty('--menu-panel-width', (this.panelWidth * 3) + 'px');
        [].forEach.call(submenus, function (el) {
          el.classList.remove('active');
        });
        this.panel2.querySelector(target_selector).classList.add('active');
        this.setExpandedChild(button);
      } else {
        this.panel.style.setProperty('--menu-panel-width', (this.panelWidth * 2) + 'px');
        this.setExpandedChild();
      }

      e.preventDefault();
    }
    onPanelLeave() {
      this.panel.style.setProperty('--menu-panel-width', (this.panelWidth * 2) + 'px');
    }
    onToggleClick() {
      this.header.classList.add('open-menu');
      this.toggle.setAttribute('aria-expanded', 'true');
      this.querySelector('.full-menu--link-parent')?.focus();
    }
    onCC() {
      this.panel.style.setProperty('--menu-panel-width', (this.panelWidth) + 'px');
      this.panel.querySelectorAll('.full-menu--subpanel').forEach(function (el) {
        el.classList.remove('active');
      });
      this.setExpandedParent();
      this.setExpandedChild();
      this.header.classList.remove('open-menu');
      this.toggle.setAttribute('aria-expanded', 'false');
    }
  }
  customElements.define('full-menu', FullMenu);
}
